export default __webpack_public_path__ + "3644fb5fa37f8231a5a6350c129e32db.png";